<template>
  <div class="login-card__welcome-card">
    <div class="top-slogan">
                Erlebe aufregende Momente
            </div>
    <p v-if="profileData" class="login-card__profile-name">
      {{ profileData.name }} <span class="login-card__profile-age">{{ profileData.age }}</span>
      <span class="login-card__is-online"></span>
    </p>

    <h1 v-if="profileData" class="login-card__title login-card__title--welcome login-card__title--welcome-from-profile">
      {{ trans.get('auth.card.welcome.header_from_profile', { name: profileData.name }) }}
    </h1>
    <h1 v-else class="login-card__title login-card__title--welcome">
      {{ trans.get('auth.card.welcome.header') }}
    </h1>

    <div>
      <a
        :href="zRoute('login.provider', 'facebook')"
        class="button button--w-100 button__fill button__fill--blue mb-3 text--smedium"
      >
        <i class="demo-icon icon-facebook pr-2"></i>{{ trans.get('auth.card.welcome.facebook_button') }}
      </a>
      <a
        :href="zRoute('login.provider', 'google')"
        class="button button--w-100 button__fill button__fill--google mb-3 text--smedium"
      >
        <img class="logo-google pr-2" src="/img/viluu/logo/google-logo.svg" alt="Logo google">
        {{ trans.get('auth.card.welcome.google_button') }}
      </a>
      <a
        :href="zRoute('login.provider', 'apple')"
        class="button button--w-100 button__fill button__fill--apple mb-3 text--smedium"
      >
        <img class="logo-apple" src="/img/viluu/logo/apple-logo.svg" alt="Logo apple">
        {{ trans.get('auth.card.welcome.apple_button') }}
      </a>
    </div>

    <div class="login-card__line">
      <div>
        <hr>
      </div>
      <p>{{ trans.get('auth.card.welcome.or') }}</p>
      <div>
        <hr>
      </div>
    </div>

    <div>
      <button
        type="button"
        class="button button--w-100 button__fill button__fill--white-mobile"
        @click="swapComponent('auth-birthday-card')"
      >
        <i class="demo-icon icon-mail-sec pr-2"></i>{{ trans.get('auth.card.welcome.register_email') }}
      </button>

      <button
        v-if="globals.profile_phone.register"
        type="button"
        class="login-card__button-phone button--w-100 button button__fill button__fill--white-mobile mt-3"
        @click="swapComponent('auth-register-phone-card')"
      >
        <i class="demo-icon icon-n-smartphone pr-2"></i>{{ trans.get('auth.card.welcome.register_phone') }}
      </button>
    </div>

    <button class="login-card__link text--smedium" @click="swapComponent('auth-login-card')">
      {{ trans.get('auth.card.welcome.member_already') }}
    </button>
  </div>
</template>
<script>
export default {
  props: ['swapComponent', 'profile'],
  data() {
    return {
      profileData: JSON.parse(this.profile)
    };
  },
  methods: {
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
  },
  activated() {
    this.refreshCSRFToken();
  }
};
</script>
<style scoped>

</style>
